import { createSlice } from '@reduxjs/toolkit'
import { diceGamePlacedBet, getDiceGameBetRecord } from './diceGame.thunk'
import { plus, minus } from 'number-precision'

const initialState = {
  loading: false,
  diceBetHistory: null,
  betResult: null,
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0,
  showDiceHistory: false,
  betHistoryData: null,
  strategyInputs: {
    stopOnProfit: 0,
    stopOnLoss: 0,
    maxBetAmount: 0,
    onWinEnabled: false,
    onWinIncreasePercent: 0,
    onLossEnabled: false,
    onLossIncreasePercent: 0
  }
}

const {
  actions: {
    setDiceBetHistory,
    resetDiceGameResult,
    setDiceLossCount,
    setDiceWinsCount,
    setDiceProfit,
    setDiceWagered,
    resetLiveStats,
    setBetHistoryData,
    setStrategyInputs
  },
  reducer
} = createSlice({
  name: 'diceGame',
  initialState,
  reducers: {
    setBetHistoryData: (state, action) => ({
      ...state,
      betHistoryData: action.payload,
      showDiceHistory: !!action.payload
    }),
    setDiceBetHistory: (state, action) => ({
      ...state,
      diceBetHistory: action?.payload
    }),
    resetDiceGameResult: (state, action) => ({
      ...state,
      betResult: null
    }),
    setDiceWinsCount: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          wins: action.payload.reset
        }
      }
      return {
        ...state,
        wins: state.wins + 1
      }
    },
    setDiceLossCount: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          losses: action.payload.reset
        }
      }
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setDiceProfit: (state, action) => {
      return {
        ...state,
        profit: plus(state.profit, minus(action.payload?.winningAmount ?? 0, action.payload?.betAmount ?? 0))
      }
    },
    setDiceWagered: (state, action) => {
      return {
        ...state,
        wagered: plus(state.wagered, action.payload)
      }
    },
    resetLiveStats: (state, action) => {
      return ({
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      })
    },
    setStrategyInputs: (state, action) => {
      return {
        ...state,
        strategyInputs: action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(diceGamePlacedBet.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(diceGamePlacedBet.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          betResult: action?.payload
        }
      })
      .addCase(diceGamePlacedBet.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
      .addCase(getDiceGameBetRecord.pending, (state, action) => {
        return {
          ...state,
          loading: true
        }
      })
      .addCase(getDiceGameBetRecord.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          diceBetHistory: action?.payload
        }
      })
      .addCase(getDiceGameBetRecord.rejected, (state, action) => {
        return {
          ...state,
          loading: false
        }
      })
  }
})

export {
  setDiceBetHistory,
  resetDiceGameResult,
  setDiceLossCount,
  setDiceWinsCount,
  setDiceProfit,
  setDiceWagered,
  setBetHistoryData,
  resetLiveStats,
  setStrategyInputs
}

export default reducer
